import Caption from '../layout/Child/Caption';
import ChildImage from '../layout/Child/ChildImage';
import Icon from '../layout/Child/Icon';


const Pdf = ({ attributes, type, mixAllData, clientId, caption, lightboxType, img, thumbnail, captionPosition, galleryIcon, ButtonContent, content, EAudio }) => {
    const { content: showContent } = attributes;
    return 'pdf' === type && <a data-fancybox={`${mixAllData ? `allDataGallery-${clientId}` : `pdf-gallery-${clientId}`}`} data-caption={caption} className="lbbmodalbtn" href={`${content === '' ? EAudio : content}`} data-type={`${content === '' ? '' : 'pdf'}`}>
        {"gallery" === lightboxType ? <div className={`contentArea ${showContent?.overlyColor && "overlyColor"}`}>
            <ChildImage img={img} thumbnail={thumbnail} />
            <Caption showContent={showContent} caption={caption} captionPosition={captionPosition} />
            <Icon type={type} galleryIcon={galleryIcon} />
        </div>
            : <button><ButtonContent /></button>
        }
    </a>

}
export default Pdf;